import { SyntheticEvent } from 'react';
import styled, { css } from 'styled-components';

const Close = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none" viewBox="0 0 12 12">
    <path
      fill="#000"
      fillRule="evenodd"
      d="M11.08.92a.583.583 0 00-.826 0L6 5.176 1.746.921a.583.583 0 00-.825.825L5.175 6 .921 10.254a.583.583 0 10.825.825L6 6.825l4.254 4.254a.583.583 0 10.825-.825L6.825 6l4.254-4.254a.583.583 0 000-.825z"
      clipRule="evenodd"
    />
  </svg>
);

interface Props {
  onClick: (event: SyntheticEvent<HTMLButtonElement>) => void;
  bg?: boolean;
}

const CloseButton = ({ onClick, bg }: Props) => (
  <Button bg={bg} onClick={onClick}>
    <Close />
  </Button>
);

export default CloseButton;

const Button = styled.button.attrs({ type: 'button' })<{ bg?: boolean }>`
  ${({ bg }) =>
    bg &&
    css`
      background: #f5f7f9;
      height: 32px;
      width: 32px;
      border-radius: 50%;
    `}
`;
